export default "__VITE_ASSET__20e9c803__"